import { Preferences } from "../../profile/objects/preferences";
import { CIRCUIT_MARGIN_MODULE } from "../constants/circuitMarginConstants";
import { Column } from "../objects/column";

export const setCircuitMarginPreference = (new_preferences: Preferences[], state_columns: Column[]): { margins_order_by: string, margins_order: 'asc' | 'desc', margins_columns: Column[], margins_preferences: Preferences[] } => {
    const field_name: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = '-created_date';
    let order: 'asc' | 'desc' = 'asc';
    new_preferences.forEach((preference: Preferences) => {
        if (preference.module === CIRCUIT_MARGIN_MODULE) {
            if (!field_name.includes(preference.field_name)) {
                switch (preference.field_name) {
                    case 'NAME':
                        columns.push({ label: 'name', field_name: preference.field_name, checked: preference.active, order_by: 'name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc ? 'name' : order_by;
                        break;
                    case 'MARGIN_TYPE':
                        columns.push({ label: 'margin-type', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'CONTENT_TYPE':
                        columns.push({ label: 'content-types', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'DESTINATION':
                        columns.push({ label: 'destination', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'COMMISSION':
                        columns.push({ label: 'commission', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'CURRENCY':
                        columns.push({ label: 'currency', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'CREATED_DATE':
                        columns.push({ label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc ? 'created_date' : order_by;
                        break;
                    case 'START_DATE':
                        columns.push({ label: 'start-date', field_name: preference.field_name, checked: preference.active, order_by: 'start_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc ? 'start_date' : order_by;
                        break;
                    case 'END_DATE':
                        columns.push({ label: 'end-date', field_name: preference.field_name, checked: preference.active, order_by: 'end_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc ? 'end_date' : order_by;
                        break;
                    case 'CREATED_BY':
                        columns.push({ label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc ? 'creator__username' : order_by;
                        break;
                    case 'MODIFIED_DATE':
                        columns.push({ label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc ? 'modified_date' : order_by;
                        break;
                    case 'MODIFIED_BY':
                        columns.push({ label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc ? 'last_author__username' : order_by;
                        break;
                    case 'ACTIVATED':
                        columns.push({ label: 'activated', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    default:
                        break;
                }
                preferences.push(preference);
                field_name.push(preference.field_name);
                order = preference.ordering_asc ? (preference.ordering_asc ? 'asc' : 'desc') : order;
            }
        }
    });
    if (columns.length !== state_columns.length) {
        state_columns.forEach(column => {
            let added = false;
            for (const element of columns) {
                if (element.label === column.label) {
                    added = true;
                    break;
                }
            }
            if (!added) {
                columns.push({ ...column });
            }
        });
    }
    return { margins_order_by: order_by, margins_order: order, margins_columns: columns, margins_preferences: preferences };
};
